import { useEffect, useState } from "react";

import { loadExternalCSS } from "common/load/utils";

/**
 * Hook to load the Mapbox JS and CSS to be used in any components
 * that display a map
 *
 * @returns a boolean indicating whether or not loading is complete
 */
export const useMapboxCSS = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const loadCSS = async () => {
      // Load the CSS and JS
      await loadExternalCSS("https://api.mapbox.com/mapbox-gl-js/v2.2.0/mapbox-gl.css");

      setIsLoaded(true);
    };

    loadCSS();
  }, []);

  return isLoaded;
};
